import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { AppStore } from 'src/app/store/store.model';
import { DialogDisplayService } from 'studio-components';
import { CollectDnaDialogData } from './types/collect-dna-dialog-data.type';

@Component({
  selector: 'app-collect-dna-dialog',
  templateUrl: './collect-dna-dialog.component.html',
  styleUrls: ['./collect-dna-dialog.component.scss'],
})
export class CollectDnaDialogComponent {
  dna$ = this.store.select(this.data.selector);
  public theme = this.data.theme;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CollectDnaDialogData,
    private dialogDisplayService: DialogDisplayService,
    private store: Store<AppStore>,
  ) {}

  public close() {
    this.dialogDisplayService.close();
  }
}
